<!-- Body Section starts -->


<section class="mt-20">
    <div>
            <div class="row">
                <div class="col-md-3 floating-input floatLabelContainer">
                    <input autoFocus id="userLoginId"  float-label type="text" class="form-control" placeholder="{{'user.Login ID' |translate |translateKey}}" tabindex="0" [(ngModel)]="userName" (keyup.enter)="searchUsers()">
                </div>
                <div class="col-md-3 floating-input floatLabelContainer">
                    <input float-label type="text" class="form-control" tabindex="0" placeholder="{{'user.First Name' |translate|translateKey}}" [(ngModel)]="firstName" (keyup.enter)="searchUsers()">
                </div>
                <div class="col-md-3 floating-input floatLabelContainer">
                    <input float-label type="text" class="form-control" tabindex="0" placeholder="{{'user.Last Name' |translate|translateKey}}" [(ngModel)]="lastName" (keyup.enter)="searchUsers()">
                </div>
                <div class="col-md-3 selectrole-multi-dp">
                  <angular2-multiselect tabindex="0"  #dropdownElem (blur)="close($event)" id="role"
                  [data]="dropdownSettings.rolesDropdown" [(ngModel)]="dropdownSettings.roleSelectedItems" 
                  [settings]="dropdownSettings.settings" 
                  (onSelect)="onItemSelect($event,dropdownSettings.roleIndex)"
                  (onDeSelect)="onItemDeSelect($event,dropdownSettings.roleIndex)" 
                  (onSelectAll)="onSelectAll($event,dropdownSettings.roleIndex)" 
                  (onDeSelectAll)="onDeSelectAll($event,dropdownSettings.roleIndex)" >
                 </angular2-multiselect>      
                </div>
                             
                <div class="col-md-12">
                    <div class="text-right">
                        <button id="search-button" class="btn blue-button" tabindex="0" type="button" (keyup.enter)="usersSearchSubmit()" (click)="usersSearchSubmit()">{{'user.Search' |translate |translateKey}}</button>
                        <button class="btn grey-button" tabindex="0" type="button" (click)="clearFields()">{{'user.Cancel' |translate|translateKey}}</button>
                        <div class="clearfix text-left font14 ptb-5">
                            <a autofocus="" *ngIf="assignUserPermission" tabindex="0" id="processor-btn" (click)="goToAssignUserView()">
                            <span class="glyphicon glyphicon-plus"></span> &nbsp;&nbsp;{{'user.ASSIGN USER' |translate |translateKey}}
                            </a>
                        </div>
                    </div>
                </div>
            </div>
       
        <div class="table-responsive dept-usersearch-grid">
            <table class="table table-striped table-hover custab mb-20">

                <thead>
                    <tr>
                        <th class="" (click)="sort('userName')" tabindex="0" (keyup.enter)="sort('userName')">{{'user.Login ID' |translate |translateKey}}&nbsp;
                            <i class="fa" [ngClass]="{'fa-sort': sortColumn != 'userName', 'fa-sort-asc': (sortColumn == 'userName' && !isDesc), 'fa-sort-desc': (sortColumn == 'userName' && isDesc) }"
                                aria-hidden="true"> </i>
                        </th>
                        <th class="" (click)="sort('firstName')" tabindex="0" (keyup.enter)="sort('firstName')">{{'user.First Name' |translate |translateKey}}&nbsp;
                            <i class="fa" [ngClass]="{'fa-sort': sortColumn != 'firstName', 'fa-sort-asc': (sortColumn == 'firstName' && !isDesc), 'fa-sort-desc': (sortColumn == 'firstName' && isDesc) }"
                                aria-hidden="true"> </i>
                        </th>
                        <th class="" (click)="sort('middleName')" tabindex="0" (keyup.enter)="sort('middleName')">{{'user.Middle Name' |translate |translateKey}}&nbsp;
                            <i class="fa" [ngClass]="{'fa-sort': sortColumn != 'middleName', 'fa-sort-asc': (sortColumn == 'middleName' && !isDesc), 'fa-sort-desc': (sortColumn == 'middleName' && isDesc) }"
                                aria-hidden="true"> </i>
                        </th>
                        <th class="" (click)="sort('lastName')" tabindex="0" (keyup.enter)="sort('lastName')">{{'user.Last Name' |translate |translateKey}}&nbsp;
                            <i class="fa" [ngClass]="{'fa-sort': sortColumn != 'lastName', 'fa-sort-asc': (sortColumn == 'lastName' && !isDesc), 'fa-sort-desc': (sortColumn == 'lastName' && isDesc) }"
                                aria-hidden="true"> </i>
                        </th>
                        <th class="" (click)="sort('email')" tabindex="0" (keyup.enter)="sort('email')">{{'user.Email' |translate |translateKey}}&nbsp;
                            <i class="fa" [ngClass]="{'fa-sort': sortColumn != 'email', 'fa-sort-asc': (sortColumn == 'email' && !isDesc), 'fa-sort-desc': (sortColumn == 'email' && isDesc) }"
                                aria-hidden="true"> </i>
                        </th>
                        <th class="" (click)="sort('phone')" tabindex="0" (keyup.enter)="sort('phone')">{{'user.Phone' |translate |translateKey}}&nbsp;
                            <i class="fa" [ngClass]="{'fa-sort': sortColumn != 'phone', 'fa-sort-asc': (sortColumn == 'phone' && !isDesc), 'fa-sort-desc': (sortColumn == 'phone' && isDesc) }"
                                aria-hidden="true"> </i>
                        </th>
                        <th class="">{{'user.Role Name' |translate}}</th>
                        <th class="">{{'user.Unassign' | translate}}</th>
                    </tr>
                </thead>
                <tbody>  
                    <tr *ngFor="let user of users | paginate: {id:'dpt-user-search-pagination', itemsPerPage: pageSize, currentPage: pageNumber, totalItems: pageCount}">
                        <td *ngIf="!user.systemUser && editUserPermission"><a (click)="goToUserView(user.userId,user.firstName)">{{user.userName}}</a></td>
                        <td *ngIf="user.systemUser">{{user.userName}}</td>
                        <td *ngIf="!user.systemUser && !editUserPermission">{{user.userName}}</td>
                        <td>{{user.firstName}}</td>
                        <td>{{user.middleName}}</td>
                        <td>{{user.lastName}}</td>
                        <td >{{user.email}}</td>
                        <td *ngIf="user.phone">{{user.phone}}</td>
                        <td *ngIf="!user.phone">NA</td>
                        <td>{{user.roleName}} </td>
                        <td><a (click)="unAssignUser(user.userId)"><img [src]="getImageURL()"/></a></td>
                    </tr>
                </tbody>
            </table>
        </div>
        {{pageCount}} {{'ticketing-system.record(s) found' |translate}}
        <pagination-controls [id]="paginationInstance.id" (pageChange)="pageChange($event)" class="pull-right"></pagination-controls>
    </div>
    <modal #unassignUserModal >
        <modal-header>
            <h4 class="color-blue">{{'user.UNASSIGN USER' | translate}}</h4>      
        </modal-header>
        <modal-content >
            <div  class="" [innerHTML]="userModalPopup.message | safeHtml">     
            </div>
        </modal-content>
        <modal-footer>
            <div class="pull-right">     
                <button class="btn blue-button" type="button" tabindex="0" (keyup.enter)="unassignUserFromDepartment(userModalPopup.userId)" (click)="unassignUserFromDepartment(userModalPopup.userId)">
                    {{'user.UNASSIGN' |translate}}                                                                                              
                </button>
                <button class="btn blue-button" type="button" tabindex="0" (keyup.enter)="closeUnAssignUserPopUp()" (click)="closeUnAssignUserPopUp()">
                    {{'user.CANCEL' |translate}}                                                                                              
                </button>
            </div>
        </modal-footer>
    </modal>
</section>


// WEBPACK FOOTER //
// ./src/app/customerservice/templates/template1/views/department/department-user-search.component.html